import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import BookingForm from '@/components/booking-form'
import Footer from '@/components/footer'
import HeroSection from '@/components/hero-section'
import HotelLoading from '@/components/layout/page-loading'
import RoomSection from '@/components/room-selection'
import ServiceSection from '@/components/service-section'
// import TestimonialsSection from '../../../components/testimonials-section'
// import VideoSection from '../../../components/video-section'

export const Route = createFileRoute('/_landing/')({
  component: RouteComponent,
})

function RouteComponent() {
  const [loading, setLoading] = useState(true)

  return (
    <div>
      {loading
        ? (
            <HotelLoading onComplete={() => setLoading(false)} duration={4000} />
          )
        : (
            <App />
          )}
    </div>
  )
}

export function App() {
  return (
    <main className="min-h-screen">
      <HeroSection />
      <BookingForm />
      <RoomSection />
      {/* <VideoSection /> */}
      <ServiceSection />
      {/* <TestimonialsSection /> */}
      <Footer />
    </main>
  )
}
